import { render, staticRenderFns } from "./product_batch_add.vue?vue&type=template&id=7c8a27d5&scoped=true&"
import script from "./product_batch_add.vue?vue&type=script&lang=js&"
export * from "./product_batch_add.vue?vue&type=script&lang=js&"
import style0 from "./product_batch_add.vue?vue&type=style&index=0&id=7c8a27d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c8a27d5",
  null
  
)

export default component.exports